import {Component, Element, h, Host, Prop} from '@stencil/core';

@Component({
    tag: 'joy-tags-list',
    styleUrl: 'tags-list.scss',
    shadow: true,
})
export class JoyTagsList {
    @Element() el!: HTMLJoyTagsListElement;

    /** Tags justify-content strategy. **/
    @Prop({reflect: true}) align: 'center' | 'left' | 'right' = 'left';

    render() {
        const align = `joy-tags-list joy-tags-list--${this.align}`;
        return (
            <Host>
                <div class={align}>
                    <slot />
                </div>
            </Host>
        );
    }
}
